<template>
    <v-card>
    <v-card-title>
      <v-toolbar  flat outlined >
          <v-icon large right>fas fa-people-carry</v-icon>
        <v-toolbar-title class="pl-3">Services {{textState}}</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
      
        <v-btn v-if="isAdministrator"  color="blue darken-3"  outlined @click="CreatenewService()">New Service
            <v-icon right dark>add_to_queue</v-icon>
        </v-btn>
      <v-spacer></v-spacer>  
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-toolbar>
    </v-card-title>
    <v-row wrap>
        <v-col cols="6" sm="6" md="6">
            <v-container v-if="isAdministrator" fluid>
                <v-radio-group v-model="seviceStatus" @change="changeStatus()" row>
                <v-radio label="Pending" value="1" color="primary"></v-radio>
                <v-radio label="Doing" value="2" color="success"></v-radio>
                <v-radio label="Finalized" value="3" color="warning"></v-radio>
                <v-radio label="Cancelled" value="4" color="error"></v-radio>
                </v-radio-group>
            </v-container>
        </v-col>

        <v-col cols="12" sm="6" md="2">
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                <template v-slot:activator="{ on }">
                    <v-text-field  v-model="dateStart" label="Start register date" prepend-icon="event" readonly v-on="on" ></v-text-field>
                </template>
                <v-date-picker color="blue darken-3" v-model="dateStart" @input="menu1 = false"></v-date-picker>
            </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
            <v-menu  v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                <template v-slot:activator="{ on }">
                    <v-text-field  v-model="dateEnd" label="End register date" prepend-icon="event" readonly v-on="on" ></v-text-field>
                </template>
                <v-date-picker color="blue darken-3" v-model="dateEnd" @input="menu2 = false"></v-date-picker>
            </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="2">
            <v-btn @click="resetFilter()" class="ma-1" tile outlined color="blue darken-3" v-if="dateStart !='' && dateEnd != ''">
                <v-icon left>fas fa-eraser</v-icon>
            </v-btn>
            <v-btn @click="exportToPDF()" class="ma-1" tile outlined color="red" v-if="desserts.length != 0">
                <v-icon left>far fa-file-pdf</v-icon>
            </v-btn>
            <v-btn @click="getAllServices()" class="ma-1" tile outlined color="blue">
                <v-icon left>fas fa-sync</v-icon>
            </v-btn>
        </v-col>
    </v-row>

        <v-data-table
        v-on:inseteCliente="traerUsuarios()"
        :headers="headers"
        :items="desserts"
        :search="search"
        disable-pagination
        disable-items-per-page
        hide-default-footer>
        <template v-slot:no-data v-if="desserts.length === 0">
            <v-progress-linear indeterminate color="green" v-if="waiting"></v-progress-linear>
            <v-alert dark class="text-xs-center" :value="true" type="warning" v-if="!waiting">No Data</v-alert>
        </template>
        <template v-slot:item.actions="{ item }">
           
            <v-tooltip bottom color="blue">
                <template v-slot:activator="{ on }">
                    <v-btn  @click="seeActivityLogs(item)" icon x-small color="blue" v-on="on">
                        <v-icon >fas fa-shoe-prints</v-icon>
                    </v-btn>
                </template>
                <span>Activity logs</span>
            </v-tooltip>

            <v-tooltip bottom color="red accent-3" v-if="seviceStatus==='1' && isAdministrator === true">
                <template v-slot:activator="{ on }">
                    <v-btn  @click="CancelService(item)" icon x-small color="red accent-3" v-on="on">
                        <v-icon >fas fa-times</v-icon>
                    </v-btn>
                </template>
                <span>Cancel Service</span>
            </v-tooltip>
            
            <v-tooltip v-if="isAdministrator" bottom color="green">
                <template v-slot:activator="{ on }">
                    <v-btn  @click="SeeService(item)" icon x-small color="green" v-on="on">
                        <v-icon >far fa-eye</v-icon>
                    </v-btn>
                </template>
                <span>See</span>
            </v-tooltip>
             <v-tooltip bottom color="blue" v-if="(seviceStatus === '1' || seviceStatus === '2') && isAdministrator === true">
                <template v-slot:activator="{ on }">
                    <v-btn  @click="finishJob(item)" icon x-small color="blue" v-on="on">
                        <v-icon >fas fa-hourglass-end</v-icon>
                    </v-btn>
                </template>
                <span>Finish Job</span>
            </v-tooltip>
            <v-tooltip v-if="isAdministrator" bottom>
                <template v-slot:activator="{ on }">
                    <v-btn  @click="deleteService(item)" icon x-small v-on="on">
                        <v-icon >far fa-trash-alt</v-icon>
                    </v-btn>
                </template>
                <span>Delete</span>
            </v-tooltip>

            <v-tooltip bottom color="orange" v-if="seviceStatus === '3' && isAdministrator === true && item.invoice === null">
                <template v-slot:activator="{ on }">
                    <v-btn small @click="GenerateInvoice(item)" class="mx-3" x-small icon color="orange" v-on="on">
                        <v-icon >far fa-file-alt</v-icon>
                    </v-btn>
                </template>
                <span>Generate Invoice</span>
            </v-tooltip>

            <v-tooltip bottom color="red" v-if="seviceStatus === '3' && isAdministrator === true && item.invoice != null">
                <template v-slot:activator="{ on }">
                    <v-btn small @click="seeInvoice(item)" class="mx-3" x-small icon color="red" v-on="on">
                        <v-icon >fas fa-print</v-icon>
                    </v-btn>
                </template>
                <span>See Invoice</span>
            </v-tooltip>
        </template>
        
        <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
            Your search "{{ search }}" not have result.
            </v-alert>
        </template>
        
        </v-data-table>
        <!--PAGINATION -->
        <div class="text-center">
            <v-container>
            <v-row justify="center">
                <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination
                    v-model="paginationPage"
                    class="my-4"
                    :length="paginationLenght"
                    :total-visible="7"
                    ></v-pagination>
                </v-container>
                </v-col>
            </v-row>
            </v-container>
        </div>
        
        <!--DIALOG TO INPUT TOTAL -->
        <v-dialog v-model="dialogTotal" width="300">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                Enter total invoice
                </v-card-title>
                <v-card-text>
                    <v-text-field
                    label="Amount"
                    v-model="total"
                    prefix="$"
                    ></v-text-field>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="dialogTotal = false" outlined>
                    Cancel
                </v-btn>
                <v-btn color="primary" text @click="openDialogInvoice()" outlined>
                    I accept
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <invoice :url=urlInvoice :dialogInvoice=dialogInvoice @close="closeDialogInvoice()"/>
        <newService :stateService=seviceStatus :dialogNewService=dialogNewService :seeService=seeService :serviceInfo=serviceInfo @closeNewService="closeNewServiceDialog()" />
    </v-card>
</template>

<script>
import {showMessageError,showMessageSuccess,showMessageWarning} from '../../services/sweetAlert'
import AlertError from '../alertas/alertErrorGlobal.vue'
import newService from './newService'
import invoice from './invoice'
import moment from 'moment'
import Swal from 'sweetalert2'

export default {
    data() {
        return {
            waiting: true,
            seviceStatus: '1',
            seeService:false,
            serviceInfo:{},
            dialogNewService:false,
            total:0,
            urlInvoice:'',
            dialogInvoice: false,
            idTravel:0,
            dialogTotal: false,
            search: '',
            desserts:[],
            headers: [
                { text: 'Id Service', align: 'center', value: 'idTravel'},
                { text: 'Customer Name', align: 'left', value: 'customerName'},
                { text: 'Service', align: 'left', value: 'service'},
                { text: 'Service date', align: 'center',  value: 'date' },
                { text: 'Register date', align: 'center',  value: 'registerDate' },
                {text: '#  Workers', align:'center', value: 'numberWorkers'},
                {text: 'Total Hours', align:'center', value: 'totalHours'},
                { text: 'Actions', value: 'actions',align: 'center', sortable: false }
            ],
            isAdministrator:false,
            userName:'',
            idUsuer:'',
            namespace:'oidcStore/',
            textState:'',
            dateStart: '',//new Date().toISOString().substr(0, 10),
            dateEnd: '',//new Date().toISOString().substr(0, 10),
            menu1: false,
            modal: false,
            menu2: false,
            dialogCalendar:false,
            files: [],
            paginationPage:1,
            paginationLenght:0
        }
    },
    watch: {
        paginationPage : function(val){
            this.getAllServices()
        },
        dateStart : function(val){
            this.paginationPage = 1
            if(this.dateStart != '' && this.dateEnd != '') this.getAllServices()
        },
        dateEnd : function(val){
            this.paginationPage = 1
            if(this.dateEnd != '' && this.dateStart != '') this.getAllServices()
        }
    },
    components:{
        'invoice' : invoice,
        'newService' : newService
    },
    mounted() {
        this.getUserName()
        this.getAllServices()
    },
    methods: {
        changeStatus(){
            this.paginationPage=1
            this.paginationLenght=0
            this.getAllServices()
        },
        finishJob(service){
            const question = Swal.mixin({
                customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
                buttonsStyling: true
            })
            question.fire({
                title: 'Do you want to finish the job?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, finish!',
                cancelButtonText: 'No, cancel!',
                reverseButtons: true
                }).then(async(result) => {
                if (result.isConfirmed) {
                    var data = new FormData()
                    data.append('Comentary','')
                    data.append('IdTravel', service.idTravel)
                    data.append('idTravelWorker', 0)
                    this.files.forEach(img =>  data.append('Images', img))

                    const response = await this.$store.dispatch('finishTask',data)
                    
                    if(response){
                        question.fire('Good!','Job finalized successfully','success')
                        this.getAllServices()
                    }else{
                        showMessageError('An error ocurred')
                    }
                }
            })
        },
        deleteService(service){
            const question = Swal.mixin({
                customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
                buttonsStyling: true
            })
            question.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel!',
                reverseButtons: true
                }).then(async(result) => {
                if (result.isConfirmed) {
                    const response = await this.$store.dispatch('deleteService', service.idTravel)
                    if(response){
                        question.fire('Deleted!','Service deleted successfully','success')
                        this.getAllServices()
                    }else{
                        showMessageError('An error ocurred')
                    }
                }
            })
        },
        exportToPDF(){
            this.urlInvoice=''
            var pg = '/page/'+this.paginationPage+'/rowsPerPage/5'
            if(this.dateStart === '' && this.dateEnd === ''){
                this.urlInvoice= 'report/'+this.seviceStatus+'/start/0/end/0'+pg
            }else{
                this.urlInvoice = 'report/'+this.seviceStatus+'/start/'+ this.dateStart+'/end/'+this.dateEnd+pg
            }
            this.dialogInvoice=true
        },
        resetFilter(){
            this.dateStart=''
            this.dateEnd=''
            this.getAllServices()
        },
        verifyRoles(rol) {
            var value = false
            const user = this.$store.getters[this.namespace + 'oidcUser'];
            //console.log('user => ',user)
            let userRoles = user.role
            this.userName = user.preferred_username;
            this.idUsuer = user.sub;
            if(userRoles instanceof Array){
                userRoles.forEach(element => {
                if(element == rol)
                    value = true
                    return 
                });
            }else{
                if(userRoles == rol) value = true
            }
            return value
        },
        getUserName(){
            if(this.verifyRoles('Administrator'))
            {
                this.isAdministrator = true
            }else{
                //console.log('no es')
                this.isAdministrator=false
            }
            //console.log('rol => ',this.isAdministrator)
        },
        seeActivityLogs(service){
            //console.log('service ==> ', service)
            if(this.verifyRoles('Administrator')){
                this.$router.push('/kanban/task/'+service.idTravel+'/travelWorker/0')
            }else{
                var id =0
                service.travelWorkers.forEach(e => {
                    if(this.userName.toLowerCase() === e.userName.toLowerCase()) {
                        id=e.idTravelWorker
                    }
                    //console.log('idtravelworker => ', id)
                })
                this.$router.push('/kanban/task/'+service.idTravel+'/travelWorker/'+ id)
            }
        },
        async CancelService(service){
            const response = await this.$store.dispatch('cancelService',service.idTravel)
            if(response.status === 200 ){
                showMessageSuccess('Good !',response.data)
                this.getAllServices()
            }else{
                showMessageError('It was not possible to cancel the service')
            }
        },
        async SeeService(service){
            var data = {idTravel: service.idTravel, idTravelWorker:0}
            const response = await this.$store.dispatch('getServiceByid',data)
            if(response.status === 200){
                this.serviceInfo=response.data
                this.seeService = true
                this.dialogNewService=true
            }else{
                showMessageError('An error has occurred')
            }
        },
        closeNewServiceDialog(){
            this.dialogNewService=false
            this.seeService=false
            this.getAllServices()
        },
        async getAllServices(){
            var filter = ''
            this.desserts = []
            if(this.dateStart ==='' && this.dateEnd === ''){
                filter='/start/0/end/0'
            }else{
                filter = '/start/'+this.dateStart+ '/end/'+this.dateEnd
            }
            this.waiting=true
            this.desserts=[]
            var state = 0
            if(this.isAdministrator){
                state = this.seviceStatus
                this.textState = ''
            }else{
                state = 3
                this.seviceStatus='3'
                this.textState = 'finished'
            }
            var pg = '/page/'+this.paginationPage+'/rowsPerPage/5'
            const services =  await this.$store.dispatch('getAllServices',state+filter+pg)
            if(services.status === 200){
                this.setInfoGrid(services.data) 
            }else{
                showMessageError('An error was ocurred')
            }
        },

        setInfoGrid(data){
            this.desserts = []
            //console.log('data ==> ', data)
            this.paginationLenght = data.pages
            data.registros.forEach(element => {
                var hour = 0
                if(this.isAdministrator) {//if the user is admin sum all hours
                    element.travelWorkers.forEach(worker => {
                        hour += worker.hours
                    });
                }else{ // if user not is admin sum only your hours
                    element.travelWorkers.forEach(worker => {
                        if(this.userName === worker.userName)
                            hour = worker.hours
                    });
                }
                this.desserts.push({
                    idTravel: element.idTravel,
                    travelWorkers: element.travelWorkers,
                    invoice: element.invoice,
                    customerName: element.customer.name,
                    date: element.date,
                    registerDate : moment(element.registerDate).format('YYYY-MM-DD') ,
                    phone: element.customer.phoneNumer,
                    numberWorkers: element.numberWorkers,
                    totalHours : hour,
                    service: element.serviceType.name
                });
            });
            this.waiting=false
        },
        GenerateInvoice(item){
            this.dialogTotal=true
            this.total=0
            this.idTravel= item.idTravel
        },
        seeInvoice(item){
            this.dialogInvoice =true
            this.urlInvoice = '/report/invoice/'+item.invoice.idInvoice
        },
        openDialogInvoice(){
            this.dialogTotal=false
            this.dialogInvoice = true
            this.urlInvoice = '/report/invoice/'+this.idTravel+'/total'+'/'+this.total
        },
        closeDialogInvoice(){
            this.dialogInvoice=false
            this.getAllServices()
        },
        CreatenewService(){
            this.dialogNewService = true
            this.seeService = false
        }
    },
}
</script>
<style scoped>
    .v-progress-linear {
    margin: 1rem;
    }
</style>